/**
 * Resets checkout form fields after a failed express checkout attempt.
 * Clears delivery and billing address inputs, removes any stored payment
 * nonce, restores the payment method to the standard flow, clears express-
 * populated name fields, and removes the loading spinner if present.
 *
 * @param {HTMLFormElement} form - The checkout account details form to reset.
 */
export function resetAccountDetailsForm(form: HTMLFormElement) {
	document
		.querySelectorAll<HTMLInputElement>(
			'input[id^="deliveryAddress-"], input[id^="billingAddress-"]',
		)
		.forEach((input) => {
			input.value = '';
		});

	// Clear nonce so stale payment data is not resubmitted
	const nonceInput = form.querySelector<HTMLInputElement>('#nonce');
	if (nonceInput) nonceInput.value = '';

	// Reset non express payment state after express fails, and clear name fields
	const paymentMethodInput = form.querySelector<HTMLInputElement>('#paymentMethod');
	if (paymentMethodInput && paymentMethodInput.value !== 'NONEXPRESS') {
		paymentMethodInput.value = 'NONEXPRESS';
		const firstNameInput = form.querySelector<HTMLInputElement>(
			'#accountDetailsForm-first-name',
		);
		const lastNameInput = form.querySelector<HTMLInputElement>('#accountDetailsForm-last-name');
		if (firstNameInput) firstNameInput.value = '';
		if (lastNameInput) lastNameInput.value = '';

		// Remove any lingering loading spinner from the express submission
		const spinner = document.querySelector('.checkout__loading');
		if (spinner) spinner.remove();
	}
}
